module.exports = __webpack_public_path__ + "images/about/saubere_filme_ueber_uns.jpg";